import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
function _callSuper(_this, derived, args) {
  function isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
      return !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
    } catch (e) {
      return false;
    }
  }
  derived = _getPrototypeOf(derived);
  return _possibleConstructorReturn(_this, isNativeReflectConstruct() ? Reflect.construct(derived, args || [], _getPrototypeOf(_this).constructor) : derived.apply(_this, args));
}
import { Component } from 'react';
import t from '@instructure/quiz-i18n/format-message';
import { eventDataPropType } from '../../../reporting/components/resources/common/propTypes';
import renderSummary from '../resources/util/renderEventSummary';
export var PageBlurredEvent = /*#__PURE__*/function (_Component) {
  function PageBlurredEvent() {
    _classCallCheck(this, PageBlurredEvent);
    return _callSuper(this, PageBlurredEvent, arguments);
  }
  _inherits(PageBlurredEvent, _Component);
  return _createClass(PageBlurredEvent, [{
    key: "render",
    value: function render() {
      var currentEventData = this.props.currentEventData;
      return renderSummary(t('Stopped viewing the quiz-taking page'), currentEventData.multipleSessionAttempt);
    }
  }]);
}(Component);
_defineProperty(PageBlurredEvent, "propTypes", {
  currentEventData: eventDataPropType
});
export default PageBlurredEvent;